(function () {
  'use strict';
  if (window.__hv2Init) return;
  window.__hv2Init = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll reveal (+ auto-stagger) ---------- */
  function initStagger(root) {
    var groups = (root || document).querySelectorAll('[data-hv2-stagger]');
    Array.prototype.forEach.call(groups, function (group) {
      if (group.__hv2Staggered) return;
      group.__hv2Staggered = true;
      var step = parseFloat(group.getAttribute('data-hv2-stagger')) || 0.08;
      var kids = group.querySelectorAll('.hv2-ani');
      Array.prototype.forEach.call(kids, function (el, i) {
        if (!el.style.getPropertyValue('--hv2-ani-delay')) {
          el.style.setProperty('--hv2-ani-delay', (i * step).toFixed(2) + 's');
        }
      });
    });
  }

  function initReveal(root) {
    initStagger(root);
    var els = (root || document).querySelectorAll('.hv2-ani:not(.hv2-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('hv2-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hv2-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  /* ---------- In-view autoplay / pause for ambient videos ---------- */
  function initVideoPause() {
    var vids = document.querySelectorAll('video[data-hv2-autopause], .hv2-hero__media video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.1 });
    Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
  }

  /* ---------- Marquee: duplicate content once for a seamless loop ---------- */
  function initMarquee(root) {
    var tracks = (root || document).querySelectorAll('.hv2-marquee__track');
    Array.prototype.forEach.call(tracks, function (track) {
      if (track.__hv2Cloned) return;
      track.__hv2Cloned = true;
      track.innerHTML += track.innerHTML;
    });
  }

  /* ---------- Parallax: data-hv2-parallax="0.15" ---------- */
  function initParallax() {
    if (REDUCED || !('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('[data-hv2-parallax]');
    if (!els.length) return;
    var active = [];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var idx = active.indexOf(entry.target);
        if (entry.isIntersecting && idx === -1) active.push(entry.target);
        else if (!entry.isIntersecting && idx !== -1) active.splice(idx, 1);
      });
    }, { rootMargin: '20% 0px' });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
    var ticking = false;
    function frame() {
      ticking = false;
      var vh = window.innerHeight;
      active.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-hv2-parallax')) || 0.15;
        var r = el.getBoundingClientRect();
        var progress = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (-progress * speed * 100).toFixed(1) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking && active.length) { ticking = true; requestAnimationFrame(frame); }
    }, { passive: true });
    frame();
  }

  /* ---------- Generic snap-track arrows: [data-hv2-track-wrap] ---------- */
  function initTrackArrows(root) {
    var wraps = (root || document).querySelectorAll('[data-hv2-track-wrap]');
    Array.prototype.forEach.call(wraps, function (wrap) {
      if (wrap.__hv2Arrows) return;
      wrap.__hv2Arrows = true;
      var track = wrap.querySelector('[data-hv2-track]');
      var prev = wrap.querySelector('[data-hv2-prev]');
      var next = wrap.querySelector('[data-hv2-next]');
      if (!track) return;
      function step() {
        var card = track.querySelector(':scope > *');
        return card ? card.getBoundingClientRect().width + 18 : track.clientWidth * 0.8;
      }
      function update() {
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  /* ---------- TikTok-style vertical video carousel (v2) ----------
     States per card: data-muted "true"/"false"; preview video uses
     data-src + preload=none and is attached on first visibility.
     Sound policy: one unmuted card at a time. Expand / card click
     opens the modal with the FULL video (data-hv2-full). */
  function initTk(root) {
    var sections = (root || document).querySelectorAll('[data-hv2-tk]');
    Array.prototype.forEach.call(sections, function (section) {
      if (section.__hv2Tk) return;
      section.__hv2Tk = true;

      var cards = section.querySelectorAll('.hv2-tk__card');
      var previewOn = section.getAttribute('data-hv2-tk-preview') !== 'false';
      var visible = [];

      function cardVideo(c) { return c.querySelector('.hv2-tk__media video'); }
      function attachSrc(v) {
        if (v && !v.src && v.getAttribute('data-src')) v.src = v.getAttribute('data-src');
      }
      function muteCard(c) {
        var v = cardVideo(c);
        if (v) v.muted = true;
        c.setAttribute('data-muted', 'true');
        var btn = c.querySelector('[data-hv2-mute]');
        if (btn) btn.setAttribute('aria-label', 'Unmute video');
      }
      function playPreview(c) {
        var v = cardVideo(c);
        if (!v) return;
        attachSrc(v);
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var c = entry.target;
            var v = cardVideo(c);
            var idx = visible.indexOf(c);
            if (entry.isIntersecting) {
              if (idx === -1) visible.push(c);
              if (v && previewOn && !REDUCED) { playPreview(c); }
            } else {
              if (idx !== -1) visible.splice(idx, 1);
              if (v) { v.pause(); muteCard(c); }
            }
          });
        }, { threshold: 0.35 });
        Array.prototype.forEach.call(cards, function (c) { io.observe(c); });
      }

      /* Modal */
      var modal = section.querySelector('.hv2-tk-modal');
      var stageVideo = modal ? modal.querySelector('video') : null;
      var chip = modal ? modal.querySelector('.hv2-tk-modal__chip') : null;
      var chipImg = chip ? chip.querySelector('img') : null;
      var chipLabel = chip ? chip.querySelector('span') : null;
      var current = -1;
      var items = [];
      Array.prototype.forEach.call(cards, function (c) {
        items.push({
          src: c.getAttribute('data-hv2-full') || c.getAttribute('data-hv2-src') || '',
          poster: c.getAttribute('data-hv2-poster') || '',
          productUrl: c.getAttribute('data-hv2-product-url') || '',
          productTitle: c.getAttribute('data-hv2-product-title') || '',
          productImg: c.getAttribute('data-hv2-product-img') || ''
        });
      });

      function pauseAllPreviews() {
        Array.prototype.forEach.call(cards, function (c) {
          var v = cardVideo(c);
          if (v) v.pause();
          muteCard(c);
        });
      }
      function resumeVisiblePreviews() {
        if (!previewOn || REDUCED) return;
        visible.forEach(function (c) { playPreview(c); });
      }

      function show(i) {
        if (!items.length || !stageVideo) return;
        current = (i + items.length) % items.length;
        var it = items[current];
        if (!it.src) return;
        stageVideo.src = it.src;
        if (it.poster) stageVideo.poster = it.poster;
        stageVideo.muted = false;
        var p = stageVideo.play();
        if (p && p.catch) p.catch(function () {});
        if (chip) {
          if (it.productUrl && it.productTitle) {
            chip.href = it.productUrl;
            if (chipLabel) chipLabel.textContent = it.productTitle;
            if (chipImg) {
              if (it.productImg) { chipImg.src = it.productImg; chipImg.hidden = false; }
              else chipImg.hidden = true;
            }
            chip.hidden = false;
          } else {
            chip.hidden = true;
          }
        }
      }
      function openModal(i) {
        if (!modal) return;
        pauseAllPreviews();
        modal.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        show(i);
      }
      function closeModal() {
        modal.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        stageVideo.pause();
        stageVideo.removeAttribute('src');
        stageVideo.load();
        resumeVisiblePreviews();
      }

      Array.prototype.forEach.call(cards, function (c, i) {
        var muteBtn = c.querySelector('[data-hv2-mute]');
        if (muteBtn) {
          muteBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            var v = cardVideo(c);
            if (!v) return;
            if (c.getAttribute('data-muted') === 'true') {
              /* single sound source: mute every other card first */
              Array.prototype.forEach.call(cards, function (o) { if (o !== c) muteCard(o); });
              attachSrc(v);
              v.muted = false;
              c.setAttribute('data-muted', 'false');
              muteBtn.setAttribute('aria-label', 'Mute video');
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              muteCard(c);
            }
          });
        }
        var expandBtn = c.querySelector('[data-hv2-expand]');
        if (expandBtn) {
          expandBtn.addEventListener('click', function (e) { e.stopPropagation(); openModal(i); });
        }
        c.addEventListener('click', function () { openModal(i); });
        c.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(i); }
        });
      });

      if (modal) {
        var closeBtn = modal.querySelector('.hv2-tk-modal__close');
        var prevBtn = modal.querySelector('.hv2-tk-modal__nav--prev');
        var nextBtn = modal.querySelector('.hv2-tk-modal__nav--next');
        if (closeBtn) closeBtn.addEventListener('click', closeModal);
        if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });
        modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
        document.addEventListener('keydown', function (e) {
          if (!modal.classList.contains('is-open')) return;
          if (e.key === 'Escape') closeModal();
          else if (e.key === 'ArrowLeft') show(current - 1);
          else if (e.key === 'ArrowRight') show(current + 1);
        });
        stageVideo.addEventListener('ended', function () { show(current + 1); });

        var touchX = null;
        modal.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
        modal.addEventListener('touchend', function (e) {
          if (touchX === null) return;
          var dx = e.changedTouches[0].clientX - touchX;
          touchX = null;
          if (Math.abs(dx) > 48) show(current + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
    });
  }

  function initAll(root) {
    initReveal(root);
    initVideoPause();
    initMarquee(root);
    initTrackArrows(root);
    initTk(root);
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  window.HV2 = { initReveal: initReveal, initAll: initAll };
})();
